import React from 'react';
import { Image, Text, View } from 'react-native-web';
import {
  getRef, getRegularFont, LocStr, xlateText,
} from '../../../../utils/Utils';
import { getImageByKey, img_scr_landscape_and, img_scr_landscape_ios } from '../../../../utils/ImagesManagementUtils';
import { Android, landscape_not_supported, no_landscape_icon } from '../../../../utils/DictionaryManagementUtils';

const Launch_not_supportedFP = ({
  globJSON,
  language,
  simPlatform,
  slideshowRefs = null,
}) => {
  const isAnd = simPlatform === Android;
  const { colors } = globJSON.configurations.theme;
  const { error_messages } = globJSON.configurations.launch;
  const myStyles = {
    phoneSimulationTopFrame: {
      height: isAnd ? 457 : 550,
      marginTop: 36 + 30,
      flexDirection: 'row',
      alignSelf: 'center',
    },
    phoneSimulationBottomFrame: {
      height: isAnd ? 457 : 550,
      marginTop: 26,
      flexDirection: 'row',
      alignSelf: 'center',
    },
    phoneScreenLeft: { width: 240, height: isAnd ? 457 : 550 },
    phoneScreenRight: {
      width: 240,
      height: isAnd ? 457 : 550,
      marginLeft: slideshowRefs !== null ? 0 : 36,
    },
    lblPhoneTitle: {
      width: 240,
      height: 20,
      marginLeft: 0,
      marginTop: 0,
      fontFamily: 'Quicksand-SemiBold',
      fontSize: 16,
      color: '#001a2f',
      position: 'absolute',
    },
    phoneImage: {
      width: 240,
      height: isAnd ? 427 : 520,
      marginTop: 30,
      position: 'absolute',
      backgroundColor: colors.app_background_color,
    },

    phoneSimulationBottomLandscapeFrame: {
      height: 240 + 30,
      width: 520,
      marginTop: 26,
      flexDirection: 'row',
      alignSelf: 'center',
    },
    phoneLandscapeImage: {
      width: isAnd ? 426 : 520,
      height: 240,
      marginTop: 30,
      position: 'absolute',
      backgroundColor: colors.app_background_color,
    },
    twoPhoneStyle: {
      width: 158,
      height: 90,
      marginLeft: isAnd ? 134 : 182,
      marginTop: isAnd ? 142 : 132,
      position: 'absolute',
    },
    txtStyle: {
      width: 220,
      height: 30,
      marginLeft: isAnd ? 113 : 150,
      marginTop: isAnd ? 221 : 211,
      position: 'absolute',
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
      fontSize: 12.4,
      textAlign: 'center',
      color: colors.secondary_font_color,

    },

  };

  //= ====================================================================

  return (
    <View ref={getRef(slideshowRefs)}>
      <Text style={myStyles.lblPhoneTitle}>
        {LocStr(landscape_not_supported, language)}
      </Text>
      <Image
        fadeDuration={0}
        style={myStyles.phoneLandscapeImage}
        source={isAnd ? img_scr_landscape_and : img_scr_landscape_ios}
      />
      <Image
        fadeDuration={0}
        resizeMode="contain"
        style={myStyles.twoPhoneStyle}
        source={getImageByKey(globJSON.configurations.launch.error_messages.no_landscape_icon, no_landscape_icon)}
      />
      <Text style={myStyles.txtStyle}>
        {xlateText(error_messages.error_message_landscape_not_supported)}
      </Text>
    </View>
  );
};

export default Launch_not_supportedFP;
